export const globalMiddleware = []